import { createColumnHelper } from '@tanstack/react-table';

import { Withdrawal } from '../_openapi/portfolio-optimizer';
import { booleanCol, dateCol, moneyCol, numberCol, textCol } from '../widgets/Table/columnHelpers/colDef';

const columnHelper = createColumnHelper<Withdrawal>();
export const withdrawalListColumns = [
    columnHelper.accessor('pId', textCol({ id: 'pId' })),
    columnHelper.accessor('portfolioName', textCol({ id: 'portfolioName' })),
    columnHelper.accessor('householdName', textCol({ id: 'householdName' })),
    columnHelper.accessor('portfolioGuid', textCol({ id: 'portfolioGuid' })),
    columnHelper.accessor('cashflowDate', dateCol({ id: 'cashflowDate' })),
    columnHelper.accessor('portfolioTargetEndDate', dateCol({ id: 'portfolioTargetEndDate' })),
    columnHelper.accessor('portfolioTaxType', textCol({ id: 'portfolioTaxType' })),
    columnHelper.accessor('withdrawalTaxRate', numberCol({ id: 'withdrawalTaxRate' })),
    columnHelper.accessor('manuallySetWithdrawalTaxRate', booleanCol({ id: 'manuallySetWithdrawalTaxRate' })),
    columnHelper.accessor('factorGuid', textCol({ id: 'factorGuid' })),
    columnHelper.accessor('withdrawalStatus', textCol({ id: 'withdrawalStatus' })),
    columnHelper.accessor('frequencyType', textCol({ id: 'frequencyType' })),
    columnHelper.accessor('yearlyInflationRate', numberCol({ id: 'yearlyInflationRate' })),
    columnHelper.accessor('inflationStartDate', dateCol({ id: 'inflationStartDate' })),
    columnHelper.accessor('cashflowUnadjustedAmount', moneyCol({ id: 'cashflowUnadjustedAmount' })),
    columnHelper.accessor('cashflowInflationMultiplier', numberCol({ id: 'cashflowInflationMultiplier' })),
    columnHelper.accessor('cashflowInflatedAmount', moneyCol({ id: 'cashflowInflatedAmount' })),
    columnHelper.accessor('cashflowGrossInflatedAmount', moneyCol({ id: 'cashflowGrossInflatedAmount' })),
    columnHelper.accessor('cashflowFinalAmount', moneyCol({ id: 'cashflowFinalAmount' })),
];
